import React,{useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Paper from '@mui/material/Paper';
import Title from './Title';

const Company = ()=> {
    const classes = useStyles();
    useEffect(()=>{
        window.scrollTo(0,0);
    },[]);    
    return (
        <div id="company" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
                <Title text="運営会社" icon="assignment"/>
                <div style={{marginBottom:"4em"}}>
                    <p>「架空ストア」「架空ストア豆本店」「井の頭倉庫」は、有限会社レトロインクが運営しています。</p>
                    <p>有限会社レトロインクはウェブアプリケーションの開発会社です。架空ストアのような委託販売に特化したオンラインストアの他、保険用のレセプト発行システムや、販売会社用の業務日報ツール、営業管理ツールなどを開発しています。</p>
                </div>
                <div className="company">
                    <table>
                        <tbody>
                            <tr>
                                <th>商号</th>
                                <td>有限会社レトロインク</td>
                            </tr>
                            <tr>
                                <th>所在地</th>
                                <td>
                                    <p>
                                        〒181-0001<br/>
                                        東京都三鷹市井の頭4-26-7<br/>
                                    </p>
                                    <p>
                                        TEL: <br/>
                                        0422-49-2903<span>（会社代表）</span><br/>
                                        0422-24-9529<span>（架空ストア）</span><br/>
                                    </p>
                                    <p className="notice">
                                        お問い合わせは<Link to="/inquiry">「お問い合わせフォーム」</Link>をご利用下さい。<br/>
                                        電話でのお問い合わせは緊急の場合を除きお断りしております。<br/>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>設立年月日</th>
                                <td>2004年10月1日</td>
                            </tr>
                            <tr>
                                <th>資本金</th>
                                <td>300万円</td>
                            </tr>
                            <tr>
                                <th>役員</th>
                                <td>
                                    代表取締役　石村寛之
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Paper>

        </div>
    )
}

export default Company;